import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/falken/falken.webp'


const _withScopeId = n => (_pushScopeId("data-v-7094d860"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "container wrapper" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "falken Tyres",
  class: "img-fluid"
}, null, -1))
const _hoisted_5 = { class: "menu_list" }
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://orders.stamford.co.za/",
    target: "_blank"
  }, "B2B")
], -1))
const _hoisted_8 = { class: "btn_group_list d-flex d-lg-none" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "btn_group_list d-none d-lg-flex" }
const _hoisted_11 = ["href"]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: { path: '/'} }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", {
        id: "navMenu",
        class: _normalizeClass(["menu", { active: _ctx.showMobileMenu }]),
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.showMobileMenu = false))
      }, [
        _createElementVNode("div", {
          id: "ToggleIcon",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.showMobileMenu = !_ctx.showMobileMenu)),
          class: _normalizeClass(["menu_bar close_toggle d-block d-lg-none", { active: _ctx.showMobileMenu }])
        }, null, 2),
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.goTO('falkenAboutUs')))
            }, "ABOUT")
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, { to: { path: '/tyre-range'} }, {
              default: _withCtx(() => [
                _createTextVNode("FALKEN PATTERNS ")
              ]),
              _: 1
            })
          ]),
          _hoisted_7,
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { path: '/news-room'} }, {
              default: _withCtx(() => [
                _createTextVNode("News Room ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { path: '/find-a-stockist'} }, {
              default: _withCtx(() => [
                _createTextVNode("Find a Stockist ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.goTO('contactUsHome'))),
              class: "btn blue_btn"
            }, "Contact Us")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              target: "_blank",
              href: _ctx.stamfordURL,
              class: "btn red_btn"
            }, "STAMFORD TYRES", 8, _hoisted_9)
          ])
        ])
      ], 2),
      _createElementVNode("ul", _hoisted_10, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: "javascript:;",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.goTO('contactUsHome'))),
            class: "btn blue_btn"
          }, "Contact Us")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.stamfordURL,
            class: "btn red_btn"
          }, "STAMFORD TYRES", 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", {
        id: "ToggleIcon",
        onClick: _cache[5] || (_cache[5] = $event => (_ctx.showMobileMenu = !_ctx.showMobileMenu)),
        class: _normalizeClass(["menu_bar d-block d-lg-none", { active: _ctx.showMobileMenu }])
      }, null, 2),
      _createElementVNode("div", {
        id: "menuOverlay",
        onClick: _cache[6] || (_cache[6] = $event => (_ctx.showMobileMenu = !_ctx.showMobileMenu)),
        class: _normalizeClass(["menu_overlay d-block d-lg-none", { active: _ctx.showMobileMenu }])
      }, null, 2)
    ])
  ]))
}